// Customer segment section configuration
// Defines fields for target customer and market segment
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for customer section
export const customerSectionSchema = z.object({
  mainCustomer: z.string().min(1, 'Este campo es requerido'),
  customerType: z.string().min(1, 'El tipo de cliente es requerido'),
  industrySector: z.array(z.string()).min(1, 'Al menos un sector es requerido'),
  operatingCountries: z.array(z.string()).min(1, 'Al menos un país es requerido'),
});

export type CustomerSectionData = z.infer<typeof customerSectionSchema>;

// Section config
export const customerSection: SectionConfig = {
  id: 'customer',
  titleKey: 'Cliente objetivo y segmento',
  descriptionKey: 'Define tu cliente ideal y segmento de mercado',
  validationSchema: customerSectionSchema,
  fields: [
    {
      name: 'mainCustomer',
      type: 'textarea',
      label: '¿Quién es tu cliente principal?',
      placeholder: 'Describe tu cliente ideal...',
      required: true,
    },
    {
      name: 'customerType',
      type: 'radio',
      label: 'Tipo de cliente',
      required: true,
      options: [
        { value: 'b2b', label: 'B2B' },
        { value: 'b2c', label: 'B2C' },
        { value: 'b2g', label: 'B2G' },
      ],
    },
    {
      name: 'industrySector',
      type: 'multiselectDropdown',
      label: 'Industria o Sector',
      required: true,
      options: [
        { value: 'tecnologico', label: 'Tecnológico' },
        { value: 'textil', label: 'Textil' },
        { value: 'salud', label: 'Salud' },
        { value: 'educacion', label: 'Educación' },
        { value: 'finanzas', label: 'Finanzas' },
        { value: 'retail', label: 'Retail' },
        { value: 'logistica', label: 'Logística' },
        { value: 'agroindustria', label: 'Agroindustria' },
        { value: 'energia', label: 'Energía' },
        { value: 'construccion', label: 'Construcción' },
      ],
    },
    {
      name: 'operatingCountries',
      type: 'multiselectDropdown',
      label: 'País donde opera',
      required: true,
      options: [
        { value: 'CR', label: 'Costa Rica' },
        { value: 'CO', label: 'Colombia' },
        { value: 'MX', label: 'México' },
        { value: 'PA', label: 'Panamá' },
        { value: 'GT', label: 'Guatemala' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'HN', label: 'Honduras' },
        { value: 'NI', label: 'Nicaragua' },
        { value: 'US', label: 'Estados Unidos' },
      ],
    },
  ],
};
